import {Box, Heading, HStack, Image, Text, VStack} from 'platform/foundation';
import styled, {useTheme} from 'styled-components';

import i18n from '@dms/i18n';

export function AiVehicleDescriptionBanner() {
  const theme = useTheme();

  return (
    <Wrapper>
      <HStack>
        <Box position="relative" width={40} overflow="hidden">
          <Box position="absolute" top={`calc(-1 * ${theme.getSize(3)})`} height={40} width={40}>
            <Image
              src="./assets/images/ai_logo.png"
              alt={i18n.t('page.advertisement.labels.aiLogoAlt')}
              fit="contain"
            />
          </Box>
        </Box>
        <Box padding={4} flex={1}>
          <VStack spacing={2}>
            <Heading size={4}>
              {i18n.t('page.advertisement.labels.aiVehicleDescriptionTitle')}
            </Heading>
            <Text size="xSmall">
              {i18n.t('page.advertisement.labels.aiVehicleDescriptionDescription')}
            </Text>
          </VStack>
        </Box>
      </HStack>
    </Wrapper>
  );
}

// Uses colors for one-time purpose
// eslint-disable-next-line eag/no-css-property
const Wrapper = styled.div`
  background: radial-gradient(100% 211.57% at 0% 0%, #a9c9fe 0%, #dfd5ff 49.5%, #f4f3f9 100%);
  padding: 0 ${({theme}) => theme.getSize(6)};
  border-radius: ${({theme}) => theme.radii.medium};
`;
